import React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    useLocation,
} from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { store, useAppSelector } from './store'; // uses Redux context
import { lightTheme, darkTheme } from './theme';
import Layout from './components/Layout/Layout';
import Login from './components/Login/login';
import MerchantTable from './components/MerchantTable';
import MerchantForm from './components/MerchantForm';
// ... other imports

import { ToastProvider } from './providers/ToastContext';
import { Provider } from 'react-redux';
import ChargesForm from './components/ChargeForm';
import MerchantById from './components/MerchantTable/MerchantById';
import BankInfoForm from './components/BankInfo/BankInfoForm';
import ProtectedRoute from './route/ProtectedRoute';
import MerchantTransactionView from './components/MerchantTable/TransactionPage';
import MerchantTransactions from './components/CalculationChanges/CalculationChanges';
import MerchantReport from './components/MerchantReport/MerchantReport';

const AppRoutes: React.FC = () => {
    const theme = useAppSelector(state => state.app.theme);
    const currentTheme = theme === 'dark' ? darkTheme : lightTheme;

    return (
        <ToastProvider>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Router>
                    <AppRoutesWithConditionalLayout />
                </Router>
            </ThemeProvider>
        </ToastProvider>
    );
};

const AppRoutesWithConditionalLayout: React.FC = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/';

    return (
        <Routes>
            <Route path="/" element={<Login />} />

            <Route
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="/merchants" element={<MerchantTable />} />
                <Route path="/merchant/create" element={<MerchantForm />} />
                <Route path="/merchant/create/:id" element={<MerchantForm />} />
                <Route path="/charges/create/:id" element={<ChargesForm />} />
                <Route path="/merchants/:id" element={<MerchantById />} />
                <Route path="/bankinfo/:id" element={<BankInfoForm />} />
                <Route
                    path="/viewTransaction/:id"
                    element={<MerchantTransactionView />}
                />
                <Route
                    path="/transaction/:id"
                    element={<MerchantTransactions />}
                />
                <Route
                    path="/generateReport/:id"
                    element={<MerchantReport />}
                />
            </Route>

            <Route path="*" element={<Login />} />
        </Routes>
    );
};

const App: React.FC = () => {
    return (
        <Provider store={store}>
            <AppRoutes />
        </Provider>
    );
};

export default App;
